import React from 'react';

import { IdleSpecialOffersPopup } from '@sravni/react-ugc/lib/IdleSpecialOffersPopup';
import { useAnalytics } from '@sravni/react-utils';
import { Tab } from '@sravni/ugc/lib/specialOffers/types';

import { AB_NAME } from '../../pages/_app';
import { useIsUserLogged } from '../../store/hooks/users';
import { isShowPopupWithSO } from '../../utils/isShowPopupWithSO';

interface SpecialOffersIdlePopupProps {
  tabs: Tab[];
}

export const SpecialOffersIdlePopup: React.FC<SpecialOffersIdlePopupProps> = ({ tabs = [] }) => {
  const isUserLogged = useIsUserLogged();
  const { pushEvent } = useAnalytics();

  if (!tabs.length || !isShowPopupWithSO) return null;

  return (
    <IdleSpecialOffersPopup
      pushEvent={pushEvent}
      abName={AB_NAME}
      tabs={tabs}
      section={'Отзывы'}
      isUserLogged={isUserLogged}
    />
  );
};
